import { Collapse, Divider, List, useTheme } from "@mui/material";
import React from "react";

import { SidebarMenuItemButton } from "./SidebarMenuItemButton";
import { SidebarMenuItems } from "./SidebarMenuItems";
import type { SidebarMenuItemRowProps } from "./types";

export const SidebarMenuItemRow: React.FC<SidebarMenuItemRowProps> = React.memo(
  (props) => {
    const {
      item,
      openItems,

      level = 0,

      collapsed = false,
    } = props;

    const theme = useTheme();
    const hasChildren = !!item.items?.length;
    const isExpanded = !!openItems[item.text];

    return (
      <>
        {item.startsWithDivider && !collapsed && (
          <Divider
            sx={{
              my: theme.spacing(2),
              borderColor: theme.palette.divider,
              opacity: 0.75,
            }}
          />
        )}
        <SidebarMenuItemButton {...props} />
        {hasChildren && !collapsed && (
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <SidebarMenuItems
                {...props}
                items={item.items!}
                level={level + 1}
              />
            </List>
          </Collapse>
        )}
      </>
    );
  }
);
